<script setup>
import TenantAppointmentTable from '@frontJs/components/tables/projectManagement/apikom/TenantAppointmentTable.vue';
import TenantReportTenantAppointmentTable from '@frontJs/components/tables/projectManagement/apikom/tenantReports/TenantAppointmentTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    all: 0,
    forthcomingAppointment: 0,
    makeAnAppointment: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(
            route('front.projectManagement.apikom.postAppointmentCount'),
        ),
        axios.post(
            route('front.projectManagement.apikom.postAppointmentCount'),
            {
                forthcoming: true,
            },
        ),
        axios.post(
            route('front.projectManagement.apikom.postAppointmentCount'),
            {
                makeAnAppointment: true,
            },
        ),
    ])
        .then((response) => {
            data.value.all = response[0].data.count;
            data.value.forthcomingAppointment = response[1].data.count;
            data.value.makeAnAppointment = response[2].data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Rendez-vous - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - Apikom - Rendez-vous
    </PageTitle>

    <TenantAppointmentTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            appointments: {
                title: 'RDV',
                items: {
                    perCustomer: {
                        title: 'Par client',
                        total: data.all,
                        content: h(TenantReportTenantAppointmentTable),
                    },
                    all: {
                        title: 'Tous',
                        content: h(TenantAppointmentTable, { all: true }),
                    },
                },
            },
            forthcomingAppointment: {
                title: 'RDV à venir',
                total: data.forthcomingAppointment,
                content: h(TenantReportTenantAppointmentTable, {
                    forthcoming: true,
                }),
            },
            makeAnAppointment: {
                title: 'Prendre RDV',
                total: data.makeAnAppointment,
                content: h(TenantReportTenantAppointmentTable, {
                    makeAnAppointment: true,
                }),
            },
        }"
        :loading="loading"
    />
</template>
